import styled from 'styled-components';
import { IonProgressBar } from '@ionic/react';

type StyledProgressBarProps = {
  fullWidth: boolean;
};

export const StyledProgressBar = styled(IonProgressBar)<StyledProgressBarProps>`
  position: absolute;
  top: 50%;
  left: 50%;

  transform: translate(-50%, -50%);

  width: ${({ fullWidth }) => (fullWidth ? '80%' : '170px')};
  height: 6px;

  border-radius: 9.26161px;

  &::part(progress) {
    background: #177590;
  }

  &::part(track) {
    background-color: #f2f4f7;
  }
`;
